export let MyOrdersUserRole;

(function (MyOrdersUserRole) {
  MyOrdersUserRole["Seller"] = "seller";
  MyOrdersUserRole["Buyer"] = "buyer";
})(MyOrdersUserRole || (MyOrdersUserRole = {}));

export let OrdersType;

(function (OrdersType) {
  OrdersType["All"] = "all";
  OrdersType["Sold"] = "sold";
  OrdersType["Purchased"] = "purchased";
})(OrdersType || (OrdersType = {}));

export let OrderStatus;

(function (OrderStatus) {
  OrderStatus["All"] = "all";
  OrderStatus["InProgress"] = "in_progress";
  OrderStatus["Completed"] = "completed";
  OrderStatus["Canceled"] = "canceled";
})(OrderStatus || (OrderStatus = {}));

export const DEFAULT_PER_PAGE = 20;